import Jobs from './jobs';
import Report from './report';

let routes = [];
routes = routes.concat({ path: 'jobs', exact: true, name: 'basic', component: <Jobs /> });
routes = routes.concat({ path: 'report', exact: true, name: 'basic', component: <Report /> });
routes = routes.concat({ path: 'report/:id', exact: true, name: 'basic', component: <Report /> });

export default routes;
